export default {
  name: 'Well Theme',
  fontFamily: '"GilroyAlt", sans-serif',
  colors: {
    accentPrimary: '#03A58F',
    accentSecondary: '#004C6A',
    accentTertiary: '#FFCD00',
    accentQuarternary: '#0061F2',
    accentQuinary: '#233645',
    textPrimary: '#233645',
    textSecondary: '#4f5e6a',
    textPlaceholder: 'rgba(0, 0, 0, 0.55)',
    textWhite: '#FFFFFF',
    textBlack: '#000000',
    divider: '#233645',
    backgroundLight: '#FFFFFF',
    backgroundGray: '#F2F6F7',
    backgroundDark: 'rgba(3, 165, 143, 0.06)',
    backgroundVeryDark: '#E6F5F4',
    destructive: '#ca503c',
    warning: '#EF6955',
    success: '#38BEAA',
    ashGray: 'rgba(0, 0, 0, 0.4)',
    disabledRow: 'rgba(240, 249, 248, 0.5)',
    haleDark: '#07283C',
    lineGrey: '#AFB7BC',
    lightgrey: '#E2E2E2'
  },
  spacing: {
    verySmall: '4px',
    small: '8px',
    regular: '16px',
    medium: '20px',
    large: '24px',
    veryLarge: '32px',
    huge: '40px',
    massive: '56px',
    superMassive: '80px',
  },
  size: {
    fileUploadText: '11px',
    button: '58px',
    buttonWidthBigger: '265px',
    buttonWidth: '180px',
    buttonSmall: '42px',
    buttonWidthSmall: '108px',
    inputButtonMobileMaxWidth: '80px',
    iconRegular: '24px',
    iconLarge: '40px',
    divider: '2px',
    iconSmall: '16px',
  },
  radius: {
    regular: '8px',
  },
  layout: {
    pageWidth: '600px',
    narrowWidth: '450px',
    topBarMaxWidth: '1040px',
    hamburgerHeight: '20px',
  },
};
